import { useTranslation } from 'react-i18next';
import { CardActionLink } from '@/common/components/CardActionLink/CardActionLink';
import { IllustrationShield } from '@/common/components/Illustrations/IllustrationShield';
import { ROUTES } from '@/common/constants/routes';
import { useGetInsurancePolicies } from '@/common/integrations/menhir/employee/insurance/insurance.hooks';
import { useGetSpotlights } from '@/common/integrations/menhir/employee/spotlights/spotlights.hooks';
import { LanguageType } from '@/common/types/general';
import { INTL_MONTH_DAY_FORMAT, intlFormat } from '@/common/utils/date';
import { useShouldDisplayFamilyMembersUI } from '@/web/containers/Insurance/InsuranceUpgrade/common/utils';

export const InsuranceUpgradePlanBanner = () => {
  const { t, i18n } = useTranslation();
  const { policies } = useGetInsurancePolicies();
  const { spotlights } = useGetSpotlights();
  const { shouldDisplayFamilyMembersUI } = useShouldDisplayFamilyMembersUI();

  if (!spotlights?.insurance?.upgradePeriod?.active) {
    return null;
  }

  const displayFamilyMembersUI = shouldDisplayFamilyMembersUI(policies?.[0]);
  return (
    <CardActionLink
      backgroundColor="accentPrimary10"
      title={t('dashboard.insurance.upgrade_plan_banner.title', {
        date: intlFormat(
          spotlights.insurance.upgradePeriod.limitDate,
          INTL_MONTH_DAY_FORMAT,
          { language: i18n.language as LanguageType }
        ),
      })}
      description={
        displayFamilyMembersUI
          ? t('dashboard.insurance.upgrade_plan_banner.description')
          : t(
              'dashboard.insurance.upgrade_plan_banner.description.no_family_members_allowed'
            )
      }
      illustration={{ asset: <IllustrationShield width={160} height={160} /> }}
      href={ROUTES.INSURANCE_UPGRADE_PLAN}
      size="md"
    />
  );
};
